export default function () {
  document.addEventListener('click', (e) => {
    if ((e.target as HTMLElement).hasAttribute('data-sort-controller')) {
      e.preventDefault()
      const value = (e.target as HTMLElement).dataset.optionValue
      if (value) {
        const query = new URLSearchParams(window.location.search)
        query.set('sort_by', value)
        location.search = query.toString()
      }
    }
  })
}
